<template>
  <div :class="['attachment', { disabled, readOnly }]">
    <a-upload
      :beforeUpload="beforeUpload"
      :fileList="fileList"
      @change="handleChange"
      @preview="showPreview"
      @remove="remove"
    >
      <div
        v-if="uploading"
        class="uploader-progress"
      >
        <a-progress
          type="circle"
          :percent="uploadProgress"
          :width="80"
          :status="uploadError ? 'exception' : 'active'"
        />
        <div
          v-if="uploadError"
          class="uploader-progress__error"
        >
          {{ $t('base.error.uploadFailed') }}
        </div>
      </div>

      <a-button v-if="!isFileAttached">
        <a-icon type="upload" />
        {{ $t('base.placeholder.upload') }}
      </a-button>
    </a-upload>

    <a-modal
      :visible="isEditing"
      :footer="null"
      width="90vw"
      height="90vh"
      :closable="false"
      @cancel="closeEditing"
    >
      <div
        v-if="isFileAttached"
        class="editWrapper"
      >
        <!-- <doc-file-editor
          :fileKey="fileList[0].uid"
          :fileUrl="fileList[0].urlFull"
        /> -->
      </div>
    </a-modal>
  </div>
</template>

<script>
import FocusOnMountMixin from '@/components/base/focusOnMount.mixin';
import { uploadFile, mediaUrl, uniqueId, getFileExtention, parseJson } from '@/helpers';
import CONFIG_QUERY from '@/queries/config';
// import DocFileEditor from '../docFileEditor/DocFileEditor.vue';

export default {
  name: 'InputAttachment',
  mixins: [FocusOnMountMixin],
  // components: { DocFileEditor },

  props: {
    value: {
      type: String,
      default: null,
    },
    config: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isEditing: false,
      uploading: false,
      uploadProgress: 0,
      uploadError: false,
    };
  },

  computed: {
    fileList: {
      get() {
        return (
          this.value && [
            {
              uid: this.value,
              name: this.value.replace(/^.*\//g, ''),
              url: this.value,
              urlFull: mediaUrl(this.value),
            },
          ]
        );
      },
      set(value) {
        this.$emit('input', value);
      },
    },

    isFileAttached() {
      return this.fileList?.length > 0;
    },
  },

  apollo: {
    editableFiles: {
      ...CONFIG_QUERY,
      fetchPolicy: 'cache-first',
      variables() {
        return {
          name: 'glob_EditableFiles',
        };
      },
      update({ table }) {
        if (table?.totalCount) {
          return parseJson(table.documents[0].data.config);
        }
        return [];
      },
      error(error) {
        this.emitError(this.$t('app.error.editableFiles'), error.message);
      },
    },
  },

  methods: {
    async setFocus() {
      // browser only allows to open file dialog in response on user generated events
      // exception -- freshly created input element, so here the hack

      if (this.fileList?.length > 0) return;

      const element = document.createElement('input');
      element.type = 'file';
      element.onchange = this.onAutoInputChange;
      element.click();
    },

    onAutoInputChange({ target }) {
      const file = target.files[0];
      if (file) {
        file.uid = uniqueId(`fileupload`);
        this.handleChange({ fileList: [file] });
      } else {
        this.handleChange({ fileList: [] });
      }
    },

    showPreview() {
      const fileExtention = getFileExtention(this.fileList[0].urlFull);
      console.log({
        conf: this.editableFiles,
        ext: fileExtention,
        includes: this.editableFiles.includes(fileExtention),
      });
      if (this.editableFiles.includes(fileExtention)) {
        this.isEditing = true;
      } else {
        window.open(this.fileList[0].urlFull, '_blank');
      }
    },

    closeEditing() {
      this.isEditing = false;
    },

    beforeUpload() {
      return false;
    },

    remove() {
      this.fileList = null;
    },

    async handleChange({ fileList }) {
      if (fileList.length > 0) {
        try {
          const file = fileList[0].originFileObj || fileList[0];

          this.uploading = true;
          this.uploadProgress = 0;
          this.uploadError = false;

          const result = await uploadFile(file, null, (progressPercent) => {
            this.uploadProgress = progressPercent;
          });

          this.uploadProgress = 100;
          this.fileList = result;

          setTimeout(() => {
            this.fileList = result;
            this.uploading = false;
            this.uploadProgress = 0;
          }, 500);
        } catch (e) {
          this.emitError(this.$t('app.error.uploading'), e.message);
        }
      } else {
        this.$emit('remove', this.fileList[0].uid);
        this.remove();
      }
    },
  },
};
</script>

<style lang="scss">
.attachment {
  max-width: 250px;

  .ant-upload-list-item:first-child {
    margin-top: 0;
    height: 24px;
  }

  &.disabled,
  &.readOnly {
    .anticon-delete {
      display: none;
    }
  }

  &[size='small'] .ant-btn {
    height: 24px;
  }
}

.editWrapper {
  width: 90vw;
  height: 90vh;
}

.uploader-progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .ant-progress-circle {
    margin-bottom: 8px;
  }

  &__error {
    margin-top: 8px;
    color: #ff4d4f;
    font-size: 12px;
  }
}
</style>
